import { useCallback, useState } from "react";
import { Page, pdfjs } from "react-pdf";
import { useIntersectionObserver } from "@wojtekmaj/react-hooks";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const observerConfig = {
    // How much of the page needs to be visible to consider page visible
    threshold: 0.6,
    root: null,
    rootMargin: "20%",
};

function PageWithObserver({ pageNumber, setPageVisibility, ...otherProps }) {
    const [page, setPage] = useState();
    const [pdfCanvasHeight, setPdfCanvasHeight] = useState(0);
    const [pdfCanvasWidth, setPdfCanvasWidth] = useState(0);


    const onIntersectionChange = useCallback(
        ([entry]) => {
            const { width, height } = entry.boundingClientRect;
            setPdfCanvasHeight(height);
            setPdfCanvasWidth(width);
            setPageVisibility(pageNumber, entry.isIntersecting, entry.boundingClientRect);
        },
        [pageNumber, setPageVisibility]
    );

    useIntersectionObserver(page, observerConfig, onIntersectionChange);

    return <>
        <canvas
            id={`demoCanvas${pageNumber}`}
            width={pdfCanvasWidth}
            height={pdfCanvasHeight}
            style={{
                border: "1px solid black",
                zIndex: 101,
                position: "absolute",
                marginLeft: "18%"
            }}
        ></canvas>
        <Page canvasRef={setPage} pageNumber={pageNumber} {...otherProps} />
    </>
}

export default PageWithObserver;